import { useApolloClient, useFragment } from "@apollo/client"

import { FloorTypename } from "shared/types/Project"

import {
  FloorCompleteFragment,
  FloorCompleteFragmentDoc
} from "entities/floors/graphql/fragments.generated"

export function useFloorFragment(id: string) {
  const { cache } = useApolloClient()

  const { complete, data: floor } = useFragment<FloorCompleteFragment>({
    fragment: FloorCompleteFragmentDoc,
    fragmentName: "FloorComplete",
    from: cache.identify({ id, __typename: FloorTypename })
      ? { id, __typename: FloorTypename }
      : null
  })

  return complete ? floor : undefined
}
